export default {"src":"/_next/static/media/delete.4e357ca9.svg","height":24,"width":24};